export const isShiftXUrl = (url: string) =>
  url.startsWith('/shiftx/processes/');
